const ProjectReview = ({
  formData = {},
  employees = [],
}) => {
  // Find selected manager from employees
  const manager = employees.find(
    (employee) =>
      String(
        employee.uuid ||
          employee.employee_uuid ||
          employee.id
      ) ===
      String(formData.project_manager_employee_uuid)
  );

  // Get manager name safely
  const managerName =
    manager?.name ||
    manager?.employee_name ||
    manager?.full_name ||
    manager?.employeeName ||
    (manager?.first_name && manager?.last_name
      ? `${manager.first_name} ${manager.last_name}`
      : "") ||
    "Not assigned";

  // Get selected members
  const memberIds =
    Array.isArray(formData.member_employee_uuids)
      ? formData.member_employee_uuids
      : [];

  const members = memberIds
    .map((id) =>
      employees.find(
        (employee) =>
          String(
            employee.uuid ||
              employee.employee_uuid ||
              employee.id
          ) === String(id)
      )
    )
    .filter(Boolean);

  return (
    <div className="space-y-6">

      {/* HEADER */}
      <div>
        <h3 className="text-xl font-bold text-slate-800">
          Review Project
        </h3>

        <p className="mt-1 text-sm text-slate-500">
          Review the project information before creating it.
        </p>
      </div>

      {/* BASIC INFORMATION */}
      <div className="rounded-xl border border-slate-200 bg-white p-6">

        <h4 className="mb-5 font-semibold text-slate-800">
          Basic Information
        </h4>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

          <ReviewItem
            label="Project Code"
            value={formData.project_code}
          />

          <ReviewItem
            label="Project Name"
            value={formData.project_name}
          />

          <ReviewItem
            label="Project Type"
            value={formData.project_type}
          />

          <ReviewItem
            label="Execution Mode"
            value={formData.execution_mode}
          />

          <ReviewItem
            label="Priority"
            value={formData.priority}
          />

          <ReviewItem
            label="Project Manager"
            value={managerName}
          />

          <ReviewItem
            label="Client"
            value={formData.client_name || "Internal"}
          />

        </div>

        {/* DESCRIPTION */}
        <div className="mt-5">
          <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
            Description
          </p>

          <p className="mt-2 text-sm text-slate-700">
            {formData.description || "No description provided"}
          </p>
        </div>

      </div>

      {/* PLANNING */}
      <div className="rounded-xl border border-slate-200 bg-white p-6">

        <h4 className="mb-5 font-semibold text-slate-800">
          Planning
        </h4>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">

          <ReviewItem
            label="Start Date"
            value={formData.planned_start_date}
          />

          <ReviewItem
            label="End Date"
            value={formData.planned_end_date}
          />

          <ReviewItem
            label="Estimated Hours"
            value={formData.estimated_hours}
          />

          <ReviewItem
            label="Estimated Cost"
            value={formData.estimated_cost}
          />

        </div>

      </div>
    </div>
  );
};


/* REVIEW ITEM */

const ReviewItem = ({ label, value }) => (
  <div>
    <p className="text-xs font-medium uppercase tracking-wide text-slate-500">
      {label}
    </p>

    <p className="mt-1 font-medium text-slate-800">
      {value || "Not specified"}
    </p>
  </div>
);

export default ProjectReview;